<div class="td-cnt-ext">
    <div class="td-cnt" [ngClass]="{'td-cnt-mobile' : isMobile}">
        <div class="td-cnt-title">
            <span class="te-title">{{ 'enquiryBook.priceMarginChangesTitle' | translate }}</span>
        </div>

        <div class="td-cnt-body">
            <p class="message">{{ 'enquiryBook.priceMarginChangesMessage' | translate }}</p>

            <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

            <div *ngIf="!isLoading" class="grid-wrapper">
                <p class="warning" *ngIf="hasLoadError">{{ 'enquiryBook.priceMarginChangesLoadError' | translate }}</p>
                <p *ngIf="!hasLoadError && dataSet.length === 0">{{ 'enquiryBook.priceMarginChangesNoRows' | translate
                    }}</p>

                <teiasoft-grid *ngIf="dataSet.length > 0" [title]="'priceMarginChangesGridTitle'"
                    [gridDescription]="'enquiryBook.priceMarginChangesGridTitle' | translate"
                    [columnsToShow]="columnsToShow" [columnsToHide]="columnsToHide" [dataSet]="dataSet"
                    [showFooter]="false" [selectable]="false" [theme]="theme" [autoWidth]="true" [sortable]="false"
                    [maxHeightVh]="48" [customRenderers]="customRenderers"
                    [customHeaderRenderers]="mergedCustomHeaderRenderers"></teiasoft-grid>
            </div>
        </div>

        <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
            <teiasoft-button *ngIf="allowReverse" (onClick)="onReverseClick()" class="mr-5" [type]="'tb-cancel'"
                [text]="'enquiryBook.priceMarginChangesReverse' | translate" [isMobile]="isMobile"></teiasoft-button>
            <teiasoft-button (onClick)="onOverviewClick()" class="mr-5" [type]="'tb-primary'"
                [text]="'enquiryBook.priceMarginChangesGoToOverview' | translate"
                [isMobile]="isMobile"></teiasoft-button>
            <teiasoft-button (onClick)="onEditPricesClick()" [type]="'tb-secondary'"
                [text]="'enquiryBook.priceMarginChangesGoToEditPrices' | translate"
                [isMobile]="isMobile"></teiasoft-button>
        </div>
    </div>
</div>

<ng-template #viewCostHeader let-column="column">
    <span>{{ getHeaderColumnLabel(column) }}</span>
</ng-template>

<ng-template #viewPreviousValue let-row let-column="column">
    <span>
        {{ formatGridValue(row[column]) }}
    </span>
</ng-template>

<ng-template #viewCurrentValue let-row let-column="column" let-previousColumn="previousColumn">
    <span [ngClass]="{'changed-current-value': hasValueChanged(row, previousColumn, column)}">
        {{ formatGridValue(row[column]) }}
    </span>
</ng-template>
